
import HTTP from '@/utils/http'
import notification from '@/utils/notification'

const prefix = '/users'

export async function getCurUserInfoByAdId (needToken = true) {
  try {
    const response = await HTTP.get(`${prefix}/current_user/profile_permission`, { headers: { needToken } })
    return response.data.data
  } catch (err) {
    notification.handleResponseError(err, 'login')
    throw err
  }
}

export async function getAllUsers (params) {
  try {
    const response = await HTTP.get(`${prefix}`, { params })
    return response.data
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}

export async function updateUsersRoles (updatingUsers) {
  try {
    await HTTP.put(`${prefix}`, { users: JSON.stringify(updatingUsers) })
  } catch (err) {
    notification.handleResponseError(err)
    throw err
  }
}
